<script setup>
</script>
<template>
  <main
    class="page-container mx-auto px-0 pb-4 md:px-4 lg:px-0 mt-4 max-w-[1302px] md:mt-6"
  >
    <div class="flex gap-10 xl:mr-6 2xl:mr-0">
      <div class="w-full flex-1">
        <main
          class="mx-auto mt-[--nf-navbar-height-m] px-4 pb-[40px] md:px-0 desktop-sm:max-w-[920px] desktop-md:max-w-[833px] desktop-lg:max-w-[930px] desktop-xl:max-w-[1035px] 4xl:max-w-[1236px]"
        >
          <div class="flex flex-col justify-center gap-3 pb-6 pt-8">
            <h1
              class="text-[32px] font-semibold leading-[110%] tracking-[-0.64px] text-black-smoky"
            >
              Asset Management Company (AMC)
            </h1>
            <p
              class="text-medium-light-gray text-sm font-normal leading-[150%] tracking-[-0.12px]"
            >
              An AMC invests the funds collected from a pool of individual
              investors and manages mutual funds by investing the money in
              various asset classes, including equity and debt instruments. Here
              you can find the list of Asset Management Companies (AMCs) in
              India.
            </p>
          </div>
          <div class="relative block md:hidden">
            <div
              class="pointer-events-none absolute inset-y-0 start-0 mb-[21px] flex items-center pr-2 ps-3 text-sm font-semibold leading-[21px] tracking-[-0.14px]"
            >
              <img
                alt="search"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                style="color: transparent"
                src="/marketing-page-assets/search-icon.svg"
              />
            </div>
            <input
              class="mb-6 w-full rounded-lg border border-jupiter p-2 pe-7 pr-3 ps-10 outline-none body-s placeholder:text-[#525252] placeholder:body-s focus:border-primary-accent3 focus-visible:outline-none"
              placeholder="Search for an AMC"
              autocomplete="off"
              autocorrect="off"
              name="amcInput"
              value=""
            />
          </div>
          <div class="flex flex-wrap gap-6">
            <a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="HDFC Asset Management Company Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00009534.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                HDFC Asset Management Company Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Nippon Life India Asset Management Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00001QYY.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Nippon Life India Asset Management Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="SBI Funds Management Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00003HJY.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                SBI Funds Management Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Quantum Asset Management Co Pvt. Ltd."
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00009537.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Quantum Asset Management Co Pvt. Ltd.
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Aditya Birla Sun Life AMC Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000349B.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Aditya Birla Sun Life AMC Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="ICICI Prudential Asset Management Company Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000953D.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                ICICI Prudential Asset Management Company Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Invesco Asset Management (India) Private Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00008KJ3.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Invesco Asset Management (India) Private Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Axis Asset Management Company Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C000049GD.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Axis Asset Management Company Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Kotak Mahindra Asset Management Co Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00001P1X.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Kotak Mahindra Asset Management Co Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="UTI Asset Management Co Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000AJYO.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                UTI Asset Management Co Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Baroda BNP Paribas Asset Management India Pvt. Ltd."
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000953A.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Baroda BNP Paribas Asset Management India Pvt. Ltd.
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Sundaram Asset Management Company Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00008JNV.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Sundaram Asset Management Company Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="PGIM India Asset Management Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00006EOL.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                PGIM India Asset Management Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="BOI AXA Investment Mngrs Private Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00001UQY.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                BOI AXA Investment Mngrs Private Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="ITI Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000BMDA.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                ITI Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="JM Financial Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00003GXW.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                JM Financial Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Groww Asset Management Ltd."
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C000095E4.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Groww Asset Management Ltd.
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Edelweiss Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00009532.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Edelweiss Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="LIC Mutual Fund Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00009535.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                LIC Mutual Fund Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Tata Asset Management Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00001W9X.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Tata Asset Management Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Mahindra Manulife Investment Management Pvt. Ltd."
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000B4QH.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Mahindra Manulife Investment Management Pvt. Ltd.
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Mirae Asset Investment Managers (India) Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000BRKM.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Mirae Asset Investment Managers (India) Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Franklin Templeton Asset Mgmt(IND) Pvt Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00008JQU.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Franklin Templeton Asset Mgmt(IND) Pvt Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="HSBC Asset Management (India) Private Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C000049H6.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                HSBC Asset Management (India) Private Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Canara Robeco Asset Management Co. Ltd."
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000953B.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Canara Robeco Asset Management Co. Ltd.
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="360 ONE Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C000093WB.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                360 ONE Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Navi AMC Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00004HKO.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Navi AMC Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Motilal Oswal Asset Management Co. Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000563U.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Motilal Oswal Asset Management Co. Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Quant Money Managers Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00009533.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Quant Money Managers Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Shriram Asset Management Co Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C00004D4M.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Shriram Asset Management Co Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="PPFAS Asset Management Pvt. Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000A4JB.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                PPFAS Asset Management Pvt. Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Samco Asset Management Pvt Ltd"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000CC2C.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Samco Asset Management Pvt Ltd
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="WhiteOak Capital Asset Management Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000BJYY.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                WhiteOak Capital Asset Management Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Bandhan Asset Management Company Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000CU70.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Bandhan Asset Management Company Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="BAJAJ FINSERV"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000CXA6.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                BAJAJ FINSERV
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="DSP Asset Managers Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000CX2H.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                DSP Asset Managers Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Zerodha Asset Management Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000D5J4.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Zerodha Asset Management Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Helios Capital Asset Management (India) Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000D5FJ.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Helios Capital Asset Management (India) Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="/marketing-page-assets/amc/forward-arrow.svg" /></a
            ><a
              class="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-jupiter px-4 py-3 hover:shadow-[0px_8px_16px_0px_rgba(26,9,42,0.12)] md:w-[48%] lg:w-[31%]"
              
              ><img
                alt="Old Bridge Asset Management Private Limited"
                loading="lazy"
                width="48"
                height="48"
                decoding="async"
                data-nimg="1"
                class="h-12 w-12 rounded-full object-contain"
                style="color: transparent"
                src="https://assets.uat1.upstox.com/content/assets/images/fundhouse/0C0000DDUY.png" />
              <p
                class="flex max-w-[187px] flex-col text-base font-semibold leading-[150%] text-black-smoky"
              >
                Old Bridge Asset Management Private Limited
              </p>
              <img
                alt="amc"
                loading="lazy"
                width="16"
                height="16"
                decoding="async"
                data-nimg="1"
                class="ml-auto block md:hidden"
                style="color: transparent"
                src="@/styles/img/marketing-page-assets/amc/forward-arrow.svg"
            /></a>
          </div>
        </main>
      </div>
      <div class="sticky mt-16 xs:hidden max-w-[320px] self-start xl:block top-36">
        <div class="flex flex-col gap-3">
          <div
            class="mb-10 flex flex-col rounded-2xl border border-gray-200 pb-6"
          >
            <div class="flex flex-col items-center justify-center">
              <div
                class="flex w-[-webkit-fill-available] flex-col items-center overflow-hidden bg-[url(~@/styles/img/marketing-page-assets/cta-bg.png)] bg-repeat-round"
              >
                <p
                  class="pt-8 text-[32px] font-semibold leading-[110%] tracking-[-0.64px] text-primary-accent3"
                >
                  Invest right.
                </p>
                <p
                  class="text-[32px] font-semibold leading-[110%] tracking-[-0.64px] text-primary-accent3"
                >
                  Invest now.
                </p>
                <img
                  alt="piggy"
                  loading="lazy"
                  width="88.9"
                  height="76.7"
                  decoding="async"
                  data-nimg="1"
                  class="pb-9 pt-4"
                  style="color: transparent"
                  src="@/styles/img/marketing-page-assets/amc/piggy.svg"
                />
              </div>
              <div class="mb-6 px-10">
                <div class="m-auto mb-4 flex items-center">
                  <div class="mr-3 min-w-[54px] text-primary-accent3">
                    <p
                      class="inline-block align-top text-lg font-normal leading-[26px]"
                    >
                      ₹
                    </p>
                    <p
                      class="text--primary-accent relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                    >
                      0
                    </p>
                  </div>
                  <div
                    class="text-sm font-normal leading-[150%] tracking-[-0.14px] text-black-smoky"
                  >
                    AMC &amp; charges* on Mutual Funds and IPO
                  </div>
                </div>
                <div class="m-auto flex items-center">
                  <div class="mr-3 min-w-[54px] text-primary-accent3">
                    <p
                      class="inline-block align-top text-lg font-normal leading-[26px]"
                    >
                      ₹
                    </p>
                    <p
                      class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                    >
                      20
                    </p>
                  </div>
                  <div
                    class="text-sm font-normal leading-[150%] tracking-[-0.14px] text-black-smoky"
                  >
                    Per order on Equity, F&amp;O, Commodity and Currency
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4">
              <button
                class="cursor-pointer px-4 text-sm font-bold disabled:cursor-not-allowed text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 w-full rounded-[100px] bg-primary-extra-dark py-3"
                type="submit"
              >
                Start investing
              </button>
            </div>
            <p
              class="max-w-[290px] px-8 pt-2 text-center text-[10px] font-normal leading-[150%] tracking-[-0.1px] text-gray-sonicSilver"
            >
              By signing up, you agree to receive transaction updates from
              Upstox.
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
